<template>
    <div>
        <dataTable :table="org_requests_table" type="org_requests" />
        <v-layout v-if="org_requests_table.content.body.length > 10" align-center wrap
                  :class="{'px-3': $vuetify.breakpoint.xs, 'mt-4 justify-center': $vuetify.breakpoint.smAndDown, 'mt-5 justify-end': $vuetify.breakpoint.mdAndUp}"
        >
            <v-flex md5 sm7 xs12>
                <div class="text-xs-center">
                    <v-pagination
                        v-model="pagination"
                        :length="pages"
                        :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </div>
            </v-flex>
            <v-flex md4 sm6 :class="{'mt-4': $vuetify.breakpoint.smAndDown}">
                <v-select
                    :items="$vuetify.breakpoint.mdAndUp ?
                      [
                        {
                          text: $t('Показывать по 10'),
                          value: 'Показывать по 10',
                        },
                        {
                          text: $t('Показывать по 25'),
                          value: 'Показывать по 25',
                        },
                        {
                          text: $t('Показывать по 50'),
                          value: 'Показывать по 50',
                        },
                        {
                          text: $t('Показывать по 100'),
                          value: 'Показывать по 100',
                        },
                      ]
                      :
                      [
                        {
                          text: $t('Показывать по 10'),
                          value: 'Показывать по 10',
                        },
                        {
                          text: $t('Показывать по 25'),
                          value: 'Показывать по 25',
                        },
                        {
                          text: $t('Показывать по 50'),
                          value: 'Показывать по 50',
                        },
                      ]"
                    solo
                    append-icon=""
                    :label="$t('Показывать по 10')"
                    class="input"
                    @change="SHOW_NUMBER({selected:$event, type: 'org'})"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import dataTable from '../Users_table';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    dataTable,
  },
  data() {
    return {
      requests: '',
    };
  },
  computed: {
    ...mapGetters('users', [
      'tab',
      'showed_filter',
    ]),
    ...mapGetters('users/modals', [
      'add_user',
      'add_organization',
    ]),
    ...mapGetters('users/requests', [
      'org_requests_table',
      'org_request_forms',
      'request_type',
    ]),
    pagination: {
      get() {
        return this.org_requests_table.content.pagination.page;
      },
      set($event) {
        return this.SET_PAGE({page: $event, type: 'org'});
      },
    },
    pages() {
      let pagination = this.org_requests_table.content.pagination;
      if (pagination.rowsPerPage == null ||
          pagination.totalItems == null
      ) return 0;

      return Math.ceil(pagination.totalItems /pagination.rowsPerPage);
    },
  },
  mounted() {
    this.get_org_requests();
    this.requests = this.org_requests_table;
    this.filter_requests();
  },
  methods: {
    filter_requests() {
      let req = this.requests.content.body.map((item, index, arr)=>{
        return item = {
          'name'        : item.name,
          'request_type': 'Организация',
          'initiator'   : item.request_by,
          'date'        : item.date,
        };
      });
      // this.requests.content.body = req;
    },
    ...mapMutations('users', [
      'SET_ACTIVE_TAB',
      'TOGGLE_FILTER',
    ]),
    ...mapMutations('users/requests', [
      'SET_PAGE',
      'SHOW_NUMBER',
    ]),
    ...mapActions('users/requests', [
      'get_org_requests',
    ]),
    ...mapMutations('users/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
  },
};
</script>
